import { Card, Divider, CardContent, CardHeader, MenuItem, TextField, Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { TextFieldNumber } from 'src/_modules/common';
import { MapItLocalizedNumberTextField } from 'src/components/common';

export default function OrderDetailsCard({ order, onChange, errors }) {

    const { t } = useTranslation();
    const [hasCashOnDelivery, setHasCashOnDelivery] = useState('no');

    // Initialize cash on delivery state based on order data
    useEffect(() => {
        if (order?.amountPayable && order?.amountPayable > 0) {
            setHasCashOnDelivery('yes');
        } else {
            setHasCashOnDelivery('no');
        }
    }, [order?.amountPayable]);

    const handleCashOnDeliveryChange = (event) => {
        const value = event.target.value;
        setHasCashOnDelivery(value);

        // If "no" is selected, clear the amount payable
        if (value === 'no') {
            onChange({
                target: {
                    name: 'amountPayable',
                    value: ''
                }
            });
        }
    };

    return (
        <Card>
            <CardHeader title={t("Order Details")} />
            <Divider />
            <CardContent>
                {t("Do you want cash on delivery service for this shipment?")}
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <RadioGroup
                                row
                                value={hasCashOnDelivery}
                                onChange={handleCashOnDeliveryChange}
                                name="cashOnDelivery"
                            >
                                <FormControlLabel
                                    value="yes"
                                    control={<Radio />}
                                    label={t("Yes")}
                                />
                                <FormControlLabel
                                    value="no"
                                    control={<Radio />}
                                    label={t("No")}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    {hasCashOnDelivery === 'yes' && 
                      (
                        <Grid item xs={12} sm={6}>
                            <MapItLocalizedNumberTextField
                                label={t("Cash to be collected")}
                                name="amountPayable"
                                value={order?.amountPayable ?? ''}
                                required={true}
                                handleChange={onChange}
                                error={!!errors?.amountPayable}
                                max={9999999}
                                helperText={errors?.amountPayable ?? ''}
                            />
                        </Grid>
                    )}
                    {/* <Grid item xs={12} sm={6}>
                        <TextField
                            name="paymentMethod"
                            label={t("Payment method")}
                            value={order?.paymentMethod ?? ''}
                            onChange={onChange}
                            fullWidth
                            variant="outlined"
                            size='small'
                            select
                            error={!!errors?.paymentMethod}
                            helperText={errors?.paymentMethod ?? ''}
                        >
                            <MenuItem value="paid">{t("paid")}</MenuItem>
                            <MenuItem value="cod">{t("cod")}</MenuItem>
                        </TextField>
                    </Grid> */}
                </Grid>
            </CardContent>
        </Card>
    );
}

